import React from "react";
import { AlertNegative, FlexContainer, Paragraph } from "heliocor-ui";

const MissingOrganization = ({ t }) => {
	return (
		<FlexContainer
			column
			padding="4rem"
			justifyContent="center"
			alignItems="center"
			width="624px"
		>
			<AlertNegative size="50px" />
			<Paragraph value={t("warning.pleaseConfigureUrl")} />
		</FlexContainer>
	);
};

export { MissingOrganization };
